import { post } from './request.js';

export const uploadToAliyun = async (file, postData) => {
	const result = await post('misc/getOssSignature', postData)
	const {
		data,
		code
	} = result
	if (code != 0) {
		return
	}

	const filename = Date.now() + '_' + file.name
	const key = data.dir + filename

	const formData = new FormData()
	formData.append('key', key)
	formData.append('policy', data.policy)
	formData.append('OSSAccessKeyId', data.accessid)
	formData.append('signature', data.signature)
	formData.append('success_action_status', '200')
	formData.append('file', file)

	const res = await fetch(data.host, {
		method: 'POST',
		body: formData
	})

	if (res.status !== 200) {
		useMessage('上传失败').show('error')
		return
	}

	const { uid, name } = file
	return { uid, store: 'aliyun', name, url: data.host + '/' + key, objectId: key }
}

const getExtensionByMime = (mime) => {
	const map = {
		'image/jpeg': '.jpg',
		'image/png': '.png',
		'image/gif': '.gif',
		'application/pdf': '.pdf',
		'text/plain': '.txt',
		'application/zip': '.zip',
		// 可继续扩展常用 MIME 类型
	};
	return map[mime] || '';
}

/**
 * 获取远程图片为本地文件对象
 */
export const fetchRemoteFile = async (url) => {
	try {
		const res = await fetch(url);
		const blob = await res.blob();

		const contentType = blob.type;
		const ext = getExtensionByMime(contentType) || '.bin'; // 默认使用 .bin
		const filename = `downloaded_file${ext}`;

		return new File([blob], filename, {
			type: contentType
		});
	} catch (ex) {

	}
}


const dataURLtoBlob = (dataUrl, type) => {
	const binary = atob(dataUrl.split(',')[1])
	const array = []
	for (let i = 0; i < binary.length; i++) {
		array.push(binary.charCodeAt(i))
	}
	return new Blob([new Uint8Array(array)], {
		type
	})
}

export const downloadFile = async (url, fileName, isAsync) => {
	if(isAsync) {
		const response = await fetch(url);
		const blob = await response.blob();
		const link = document.createElement('a');
		link.href = URL.createObjectURL(blob);
		link.download = fileName || 'downloadFile';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		//URL.revokeObjectURL(link.href); // 释放内存
		setTimeout(() => URL.revokeObjectURL(link.href), 1000);
	}
	else {
		// fallback：直接打开 URL（跨域时浏览器可能直接下载或打开）
		const link = document.createElement('a');
		link.href = url;
		link.target = '_blank';
		link.download = fileName || 'downloadFile';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
}

export const downloadExcelFile = (fileNameEncode, fileBlob, fileType) => {
	// 解码
	const fileName = decodeURIComponent(fileNameEncode)
	// 设置type类型
	const blob = new Blob([fileBlob], {
		type: fileType ||
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; application/octet-stream'
	})
	const fileUrl = window.URL.createObjectURL(blob)

	const a = document.createElement('a')
	a.href = fileUrl
	a.setAttribute('download', fileName)
	a.style.display = 'none'
	a.click()
	a.remove()
}

export const printImage = (attach) => {
	if(!attach || !Array.isArray(attach)) {
		return 
	}
		
	const win = window.open('', 'print_' + Date.now());
	
	const images = attach.map(img => {
		return `<img src="${img.url}" alt="" />`;
	})
	
	win.document.write(`
    <html>
      <head>
        <title>打印图片</title>
        <style>
          body {
            margin: 0;
            padding: 10px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
          }
          img {
            max-width: 100%;
            margin: 10px;
            page-break-inside: avoid; /* 防止分页时图片被切开 */
          }
        </style>
      </head>
      <body>
        ${images.join('')}
        <script type="text/javascript">
			const imgs = document.querySelectorAll('img');
			let loaded = 0;
			imgs.forEach(img => {
				img.onload = () => {
					loaded++;
					if (loaded === imgs.length) {
					// 等所有图片加载完成再打印
						setTimeout(() => {
							window.print();
							window.close();
						}, 200);
					}
				};
			});
        <\/script>
      </body>
    </html>
	`);
	win.document.close();
}

export function compressImage(file) {
	return new Promise(resolve => {
		const reader = new FileReader()
		const image = new Image()
		image.onload = (imageEvent) => {
			const canvas = document.createElement('canvas'); // 创建画布
			const context = canvas.getContext('2d');

			const width = image.width / 3;
			const height = image.height / 3;

			canvas.width = width;
			canvas.height = height;
			context.clearRect(0, 0, width, height);
			context.drawImage(image, 0, 0, width, height);
			const dataUrl = canvas.toDataURL(file.type);
			const blobData = dataURLtoBlob(dataUrl, file.type);
			resolve(blobData);
		}

		reader.onload = e => {
			image.src = e.target.result
		}
		reader.readAsDataURL(file)
	})
}
